import React from 'react';
import SectionHeadline from '@/components/ui/elements/SectionHeadline';
import Cta from '@/components/ui/buttons/Cta';

interface CaseStudyCtaProps {
  title?: string;
  buttonTitle?: string;
  buttonAction?: string;
  buttonBgColor?: { hex: string };
  buttonTextColor?: { hex: string };
}

const CaseStudyCta: React.FC<CaseStudyCtaProps> = ({
  title = 'Working on something similar?',
  buttonTitle = 'Start a conversation',
  buttonAction = '/contact',
  buttonBgColor,
  buttonTextColor,
}) => {
  const buttonStyle = {
    ...(buttonBgColor?.hex ? { backgroundColor: buttonBgColor.hex, '--cta-hover-shadow': buttonBgColor.hex } : {}),
    ...(buttonTextColor?.hex ? { color: buttonTextColor.hex } : {}),
  } as React.CSSProperties;

  return (
    <section className="px-6 pt-12 pb-16 text-center sm:px-8">
      <SectionHeadline as="h3" xs={32} sm={32} md={32} lg={32}>
        {title}
      </SectionHeadline>
      <div className="mt-6">
        <Cta to={buttonAction} style={Object.keys(buttonStyle).length ? buttonStyle : undefined}>
          {buttonTitle}
        </Cta>
      </div>
    </section>
  );
};

export default CaseStudyCta;
